/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckCheck, PaxCheckCheckFromJSONTyped, PaxCheckCheckToJSON } from "./PaxCheckCheck";
import { PaxCheckComposedAnd, PaxCheckComposedAndFromJSONTyped, PaxCheckComposedAndToJSON } from "./PaxCheckComposedAnd";
import { PaxCheckComposedOr, PaxCheckComposedOrFromJSONTyped, PaxCheckComposedOrToJSON } from "./PaxCheckComposedOr";
import { PaxCheckFieldCompare, PaxCheckFieldCompareFromJSONTyped, PaxCheckFieldCompareToJSON } from "./PaxCheckFieldCompare";
import { PaxCheckFieldIn, PaxCheckFieldInFromJSONTyped, PaxCheckFieldInToJSON } from "./PaxCheckFieldIn";
import { PaxCheckFieldNotIn, PaxCheckFieldNotInFromJSONTyped, PaxCheckFieldNotInToJSON } from "./PaxCheckFieldNotIn";
import { PaxCheckNot, PaxCheckNotFromJSONTyped, PaxCheckNotToJSON } from "./PaxCheckNot";


/**
 * @type PaxCheckChecklistItemRequirement
 * 
 * @export
 */
export type PaxCheckChecklistItemRequirement = { type: 'check' } & PaxCheckCheck | { type: 'composed-and' } & PaxCheckComposedAnd | { type: 'composed-or' } & PaxCheckComposedOr | { type: 'field-compare' } & PaxCheckFieldCompare | { type: 'field-in' } & PaxCheckFieldIn | { type: 'field-not-in' } & PaxCheckFieldNotIn | { type: 'not' } & PaxCheckNot;

export function PaxCheckChecklistItemRequirementFromJSON(json: any): PaxCheckChecklistItemRequirement {
    return PaxCheckChecklistItemRequirementFromJSONTyped(json, false);
}

export function PaxCheckChecklistItemRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistItemRequirement {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'check':
            return Object.assign({}, PaxCheckCheckFromJSONTyped(json, true), { type: 'check' } as const);
        case 'composed-and':
            return Object.assign({}, PaxCheckComposedAndFromJSONTyped(json, true), { type: 'composed-and' } as const);
        case 'composed-or':
            return Object.assign({}, PaxCheckComposedOrFromJSONTyped(json, true), { type: 'composed-or' } as const);
        case 'field-compare':
            return Object.assign({}, PaxCheckFieldCompareFromJSONTyped(json, true), { type: 'field-compare' } as const);
        case 'field-in':
            return Object.assign({}, PaxCheckFieldInFromJSONTyped(json, true), { type: 'field-in' } as const);
        case 'field-not-in':
            return Object.assign({}, PaxCheckFieldNotInFromJSONTyped(json, true), { type: 'field-not-in' } as const);
        case 'not':
            return Object.assign({}, PaxCheckNotFromJSONTyped(json, true), { type: 'not' } as const);
        default:
            return json;
    }
}

export function PaxCheckChecklistItemRequirementToJSON(json: any): any {
    return PaxCheckChecklistItemRequirementToJSONTyped(json, false);
}

export function PaxCheckChecklistItemRequirementToJSONTyped(value?: PaxCheckChecklistItemRequirement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'check':
            return Object.assign({}, PaxCheckCheckToJSON(value), { type: 'check' } as const);
        case 'composed-and':
            return Object.assign({}, PaxCheckComposedAndToJSON(value), { type: 'composed-and' } as const);
        case 'composed-or':
            return Object.assign({}, PaxCheckComposedOrToJSON(value), { type: 'composed-or' } as const);
        case 'field-compare':
            return Object.assign({}, PaxCheckFieldCompareToJSON(value), { type: 'field-compare' } as const);
        case 'field-in':
            return Object.assign({}, PaxCheckFieldInToJSON(value), { type: 'field-in' } as const);
        case 'field-not-in':
            return Object.assign({}, PaxCheckFieldNotInToJSON(value), { type: 'field-not-in' } as const);
        case 'not':
            return Object.assign({}, PaxCheckNotToJSON(value), { type: 'not' } as const);
        default:
            return value;
    }
}

